const toFiniteNumber = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export const normalizeQuantityDiscountRules = (rules) => {
  if (!Array.isArray(rules)) return [];

  const deduped = new Map();

  rules.forEach((rule) => {
    const minQuantity = Math.floor(toFiniteNumber(rule?.minQuantity, 0));
    const discountPercent = Math.min(
      100,
      Math.max(0, toFiniteNumber(rule?.discountPercent, 0)),
    );

    if (minQuantity < 1 || discountPercent <= 0) return;

    deduped.set(minQuantity, {
      minQuantity,
      discountPercent,
      details: typeof rule?.details === "string" ? rule.details.trim() : "",
    });
  });

  return Array.from(deduped.values()).sort(
    (left, right) => left.minQuantity - right.minQuantity,
  );
};

export const resolveQuantityDiscount = (rules, quantity) => {
  const normalizedRules = normalizeQuantityDiscountRules(rules);
  const normalizedQty = Math.max(1, Math.floor(toFiniteNumber(quantity, 1)));

  const appliedRule = normalizedRules.reduce((current, rule) => {
    if (normalizedQty >= rule.minQuantity) return rule;
    return current;
  }, null);

  return {
    normalizedRules,
    appliedRule,
  };
};

export const calculateDeliveryPricing = ({
  price = 0,
  discount = 0,
  quantity = 1,
  quantityDiscountRules = [],
}) => {
  const basePrice = Math.max(0, toFiniteNumber(price, 0));
  const fixedDiscount = Math.max(0, toFiniteNumber(discount, 0));
  const normalizedQty = Math.max(1, Math.floor(toFiniteNumber(quantity, 1)));
  const unitPriceAfterFixedDiscount = Math.max(0, basePrice - fixedDiscount);

  const { normalizedRules, appliedRule } = resolveQuantityDiscount(
    quantityDiscountRules,
    normalizedQty,
  );
  const quantityDiscountPercent = appliedRule?.discountPercent || 0;
  const quantityDiscountPerUnit = Math.round(
    (unitPriceAfterFixedDiscount * quantityDiscountPercent) / 100,
  );

  const finalUnitPrice = Math.max(
    0,
    unitPriceAfterFixedDiscount - quantityDiscountPerUnit,
  );
  const subtotalBeforeQuantityDiscount = unitPriceAfterFixedDiscount * normalizedQty;
  const quantityDiscountTotal = quantityDiscountPerUnit * normalizedQty;
  const finalTotal = finalUnitPrice * normalizedQty;

  return {
    basePrice,
    fixedDiscount,
    normalizedQty,
    normalizedRules,
    appliedRule,
    quantityDiscountPercent,
    quantityDiscountPerUnit,
    quantityDiscountTotal,
    unitPriceAfterFixedDiscount,
    finalUnitPrice,
    subtotalBeforeQuantityDiscount,
    finalTotal,
  };
};
